export const YES_NO = Object.freeze({ NO: 0, YES: 1 });
export const YES_NO_OPTIONS = Object.freeze([{ id: YES_NO.YES, name: "Yes" }, { id: YES_NO.NO, name: "No" }]);
